// src/config.js
// Centralized environment-aware configuration for PMS-Dashboard + InventoryStream

const config = {
  // API base URL
  apiUrl:
    process.env.NODE_ENV === "development"
      ? "" // proxy handles it in dev
      : process.env.REACT_APP_API_URL,

  // Role (admin/user)
  role: process.env.REACT_APP_ROLE,

  // Cross-app navigation
  inventoryUrl: process.env.REACT_APP_INVENTORY_URL, // PMS → InventoryStream
  pmsUrl: process.env.REACT_APP_PMS_URL              // InventoryStream → PMS
};

export default config;
